module.exports = __webpack_public_path__ + "img/dual-layer-ha.7522948a.png";